export enum LUMAPPS_APPLICATIONS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826323065
     */
    ACCESS_SETTINGS = 'LUMAPPS_APPLICATIONS.ACCESS_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499349
     */
    ADD_ATTRIBUTE_PAIR = 'LUMAPPS_APPLICATIONS.ADD_ATTRIBUTE_PAIR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499284
     */
    ADDITIONAL_ATTRIBUTES = 'LUMAPPS_APPLICATIONS.ADDITIONAL_ATTRIBUTES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826923566
     */
    ALLOWED_USERS = 'LUMAPPS_APPLICATIONS.ALLOWED_USERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=863304919
     */
    APPLICATION_CREATE_ERROR = 'LUMAPPS_APPLICATIONS.APPLICATION_CREATE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499372
     */
    APPLICATION_CREATED = 'LUMAPPS_APPLICATIONS.APPLICATION_CREATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=836160996
     */
    APPLICATION_DELETED = 'LUMAPPS_APPLICATIONS.APPLICATION_DELETED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=688348116
     */
    APPLICATION_ID = 'ASK_AI_SOURCES.VERTEX_AI_APPLICATION_ID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826923584
     */
    APPLICATION_ID_COPIED = 'LUMAPPS_APPLICATIONS.APPLICATION_ID_COPIED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=864117611
     */
    APPLICATION_SECRET = 'LUMAPPS_APPLICATIONS.APPLICATION_SECRET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=830805869
     */
    APPLICATION_TYPE = 'LUMAPPS_APPLICATIONS.APPLICATION_TYPE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499368
     */
    ATTRIBUTE_NAME_BLOCKED = 'LUMAPPS_APPLICATIONS.ATTRIBUTE_NAME_BLOCKED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499369
     */
    ATTRIBUTE_NAME_DUPLICATED = 'LUMAPPS_APPLICATIONS.ATTRIBUTE_NAME_DUPLICATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499367
     */
    AUDIENCE_ALREADY_IN_USE = 'LUMAPPS_APPLICATIONS.AUDIENCE_ALREADY_IN_USE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499376
     */
    AUDIENCE_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.AUDIENCE_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826923634
     */
    AUTHORIZATION_CODE_MCP = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_MCP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=864117526
     */
    AUTHORIZATION_CODE_SUMMARY_INFO_BANNER = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_SUMMARY_INFO_BANNER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=864117567
     */
    AUTHORIZATION_CODE_SUMMARY_SECRET_WARNING = 'LUMAPPS_APPLICATIONS.AUTHORIZATION_CODE_SUMMARY_SECRET_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=482010540
     */
    CLIENT_CREDENTIALS = 'CONNECTORS.CLIENT_CREDENTIALS_NEW',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826923637
     */
    COPY_APPLICATION_ID = 'LUMAPPS_APPLICATIONS.COPY_APPLICATION_ID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=864117685
     */
    COPY_APPLICATION_SECRET = 'LUMAPPS_APPLICATIONS.COPY_APPLICATION_SECRET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=835486795
     */
    COPY_IDENTITY_AUDIENCE = 'LUMAPPS_APPLICATIONS.COPY_IDENTITY_AUDIENCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=836160985
     */
    DELETE_CONFIRM_DESCRIPTION = 'LUMAPPS_APPLICATIONS.DELETE_CONFIRM_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=836160977
     */
    DELETE_CONFIRM_TITLE = 'LUMAPPS_APPLICATIONS.DELETE_CONFIRM_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=836160997
     */
    DELETE_ERROR = 'LUMAPPS_APPLICATIONS.DELETE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=839515464
     */
    EDIT_LUMAPPS_IDENTITY_TITLE = 'LUMAPPS_APPLICATIONS.EDIT_LUMAPPS_IDENTITY_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=865472493
     */
    EDIT_AC_CONFIRM_TITLE = 'LUMAPPS_APPLICATIONS.EDIT_AC_CONFIRM_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=865472514
     */
    EDIT_AC_CONFIRM_DESCRIPTION = 'LUMAPPS_APPLICATIONS.EDIT_AC_CONFIRM_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=839515476
     */
    EDIT_CONFIRM_TITLE = 'LUMAPPS_APPLICATIONS.EDIT_CONFIRM_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=839515814
     */
    EDIT_CONFIRM_DESCRIPTION = 'LUMAPPS_APPLICATIONS.EDIT_CONFIRM_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=839515868
     */
    APPLICATION_UPDATED = 'LUMAPPS_APPLICATIONS.APPLICATION_UPDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=839515871
     */
    UPDATE_ERROR = 'LUMAPPS_APPLICATIONS.UPDATE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=167753986
     */
    LUMAPPS_IDENTITY = 'ADMIN.CUSTOMER.IDENTITY_PROVIDER_INTERNAL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826323016
     */
    NAME = 'LUMAPPS_APPLICATIONS.NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826327985
     */
    NEW_APPLICATION = 'LUMAPPS_APPLICATIONS.NEW_APPLICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=826923641
     */
    NO_APPLICATION_YET = 'LUMAPPS_APPLICATIONS.NO_APPLICATION_YET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499380
     */
    PROFILE_FIELD_EMPLOYEE_ID = 'LUMAPPS_APPLICATIONS.PROFILE_FIELD_EMPLOYEE_ID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499366
     */
    PROFILE_FIELDS_FROM_PLATFORM = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_FROM_PLATFORM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=834499378
     */
    PROFILE_FIELDS_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=863304921
     */
    REDIRECT_URL_INVALID = 'LUMAPPS_APPLICATIONS.REDIRECT_URL_INVALID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=867598869
     */
    REQUIRE_PKCE = 'LUMAPPS_APPLICATIONS.REQUIRE_PKCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=867598877
     */
    REQUIRE_PKCE_HELPER = 'LUMAPPS_APPLICATIONS.REQUIRE_PKCE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=864117743
     */
    SECRET_STORED_CONFIRMATION = 'LUMAPPS_APPLICATIONS.SECRET_STORED_CONFIRMATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=835486673
     */
    SUMMARY_INFO_BANNER = 'LUMAPPS_APPLICATIONS.SUMMARY_INFO_BANNER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=835486794
     */
    SUMMARY_STORE_WARNING = 'LUMAPPS_APPLICATIONS.SUMMARY_STORE_WARNING',
}
